import React from 'react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

import type BigNumber from 'bignumber.js'

type Props = {
  label: string
  color?: string
  marketCapacity?: BigNumber | undefined
  children: React.ReactNode
}

export const TradePositionDetailsTableRow: React.FC<Props> = ({
  label,
  color,
  children,
  marketCapacity,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Label>{label}</Label>
      <Underline />
      {marketCapacity && (
        <MarketCapacity>
          {t('common.mcap-short')}{' '}
          <Numeric
            value={marketCapacity}
            preset="currency-amount-short"
            currency="$"
          />
        </MarketCapacity>
      )}
      <Value $color={color}>{children}</Value>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;

  align-items: end;
`

const MarketCapacity = styled.span`
  color: var(--text-9);

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 133.333% */
`

const Underline = styled.span`
  border-bottom: 1px solid ${({ theme }) => theme.color.white[10]};
  flex: 1;
  margin-bottom: 3px;
`

const Label = styled.span`
  color: var(--text-11);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;

  &::first-letter {
    text-transform: uppercase;
  }
`

const Value = styled.span<{ $color?: string }>`
  color: ${({ $color }) => ($color ? $color : 'var(--text-12)')};

  text-align: right;
  font-style: normal;

  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`
